// extracted by mini-css-extract-plugin
module.exports = {"containerBrand":"styles_containerBrand__37spB","brandLabel":"styles_brandLabel__spu4I","inputBrand":"styles_inputBrand__3bMn7"};